angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-calendar-factory',
        function ($api, $factory) {
            $api.factory.calendar = $factory;
        },
    ])
    .factory('graph-calendar-factory', [
        'graph-api-client',
        function (client) {
            return {
                query: function (id, options) {
                    return client.get([id, 'calendar'], options);
                },
            };
        },
    ]);
